<ion-grid *ngIf="!!item"
          [class.child]="level > 1"
          [class.remove-padding]="removePadding"
          [class.large-font]="largeFont"
          [id]="!!itemSummary ? 'item_summary_' + itemSummary.key : 'item_' + item.id">
    <ion-row *ngIf="level === 1 && !hideHeader && !details">
        <ion-col *ngIf="!hideImages && level === 1 && !hideHeader" size-xs="4">
            <bb-menu-item-image *ngIf="!!item && count > 0"
                                [nameOverride]="getNameOverride()"
                                [menuItem]="item.menuItem"
                                [orderDisplay]="true"
                                [orderType]="item.orderType"
                                [showImageOverride]="showImageOverride"
                                (imageLoaded)="imageLoaded.emit()"></bb-menu-item-image>
            <div *ngIf="!!count && count > 1 && !editable" class="count-badge">x{{ count }}</div>
            <div *ngIf="editable && (!miscItem || (!!item.membershipRenewal && !!item.membershipRenewal.membershipProgram && !item.membershipRenewal.membershipProgram.lifetime))"
                 class="order-item-counter">
                <bb-counter [value]="!!item.membershipRenewal ? item.membershipRenewal.quantity : count"
                            [scale]="true"
                            [displayAdd]="editable"
                            (add)="addClicked()"
                            (remove)="removeClicked()">
                </bb-counter>
            </div>
        </ion-col>
        <ion-col [sizeXs]="!hideImages ? 8 : 12" class="item-info-container" [class.remove-padding]="removePadding">
            <ion-grid>
                <ng-container>
                    <ion-row>
                        <ion-col *ngIf="!!item.membershipRenewal" class="item-name">
                            <ng-container *ngIf="!!item.membershipRenewal.membershipName; else noPerson">
                                <span>{{ item.membershipRenewal.membershipName }}</span>
                                <p class="sub-header">{{ item.membershipRenewal.getDescription() | underscoreConversion }}</p>
                            </ng-container>
                            <ng-template #noPerson>
                                <span>{{ item.membershipRenewal.getDescription()  | underscoreConversion }}</span>
                            </ng-template>
                        </ion-col>
                        <ion-col *ngIf="!item.membershipRenewal" class="item-name">
                            {{
                                !miscItem
                                    ? item.menuItem.name
                                    : (!item.giftCard ? item.notes : item.giftCard.cardNumber)
                            }} {{
                                !!item.selectedPrice && !!item.selectedPrice.name && item.selectedPrice.name.toLowerCase() !== 'default'
                                    ? '(' + item.selectedPrice.name + ') '
                                    : ''
                            }}
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col *ngIf="hideImages">
                            <bb-counter
                                    *ngIf="editable && (!miscItem || (!!item.membershipRenewal && !!item.membershipRenewal.membershipProgram && !item.membershipRenewal.membershipProgram.lifetime))"
                                    [value]="!!item.membershipRenewal ? item.membershipRenewal.quantity : count"
                                    [scale]="true"
                                    [displayAdd]="editable"
                                    (add)="addClicked()"
                                    (remove)="removeClicked()">
                            </bb-counter>
                        </ion-col>
                        <ion-col *ngIf="!item.selectedPrice"
                                 class="ion-text-end item-price"
                                 [class.remove-padding]="removePadding"
                                 [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                            <span *ngIf="!item.membershipFeeIncluded">{{
                                    !!item.priceOverride
                                        ? item.priceOverride
                                        : item.total | currency
                                }}
                            </span>
                            <span *ngIf="item.membershipFeeIncluded">{{
                                    addCurrency(item.total, item.membershipFees) | currency
                                }}
                            </span>
                            <div class="remove-container"><a *ngIf="editable" class="remove-misc" (click)="removeMisc($event)">Remove</a></div>
                        </ion-col>
                        <ng-container *ngIf="!!item.selectedPrice">
                            <ion-col *ngIf="!!item.tokenPayment; else nonTokenPrice"
                                     class="ion-text-end item-price"
                                     [class.remove-padding]="removePadding"
                                     [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                                <div class="token-price-container">
                                    <bb-tokens [count]="adjustedTokenPrice(item.tokenPayment)"
                                               (click)="$event.stopPropagation(); removeTokens.emit(item)"></bb-tokens>
                                </div>
                            </ion-col>
                            <ng-template #nonTokenPrice>
                                <ion-col *ngIf="!hideTotal" class="ion-text-end item-price"
                                         [class.remove-padding]="removePadding"
                                         [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                                    <span (click)="useTokens($event)">{{
                                            adjustedPrice(item.selectedPrice.variable
                                                ? item.priceOverride
                                                : item.selectedPrice.price) | currency
                                        }}</span> <span *ngIf="item.selectedPrice.deposit" class="deposit-label">Deposit</span>
                                </ion-col>
                            </ng-template>
                        </ng-container>

                        <ion-col *ngIf="!hideTotal && additionalPrice"
                                 class="ion-text-end item-price"
                                 [class.remove-padding]="removePadding"
                                 [class.canceled-price]="orderStatus === orderStatuses.CANCELED">{{ adjustedPrice(additionalPrice) | currency }}
                        </ion-col>
                    </ion-row>
                </ng-container>
            </ion-grid>
        </ion-col>
    </ion-row>

    <ion-row *ngIf="level === 1 && details">
        <ion-col size-xs="9" size-md="10" *ngIf="!miscItem">
            {{ item.menuItem.name }} {{
                !!item.selectedPrice && !!item.selectedPrice.name && item.selectedPrice.name.toLowerCase() !== 'default'
                    ? '(' + item.selectedPrice.name + ') '
                    : ''
            }}
        </ion-col>

        <ion-col size-xs="9" size-md="10" *ngIf="miscItem">
            <span>{{ getNameOverride() }}</span>
            <p *ngIf="!!item.giftCard" class="sub-header">{{ item.giftCard.cardNumber }}</p>
            <p *ngIf="!!item.membershipRenewal" class="sub-header">{{ item.membershipRenewal.getDescription() | underscoreConversion }}</p>
            <p *ngIf="!item.membershipRenewal && !item.giftCard && item.notes" class="sub-header">{{ item.notes }}</p>
        </ion-col>

        <ion-col class="ion-text-end">
            <ng-container *ngIf="!hideTotal && !item.tokenPayment">
                <ng-container *ngIf="!!item.priceOverride"
                              class="line-item-price"
                              [class.remove-padding]="removePadding"
                              [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                    {{ adjustedPrice(item.priceOverride) | currency }}
                </ng-container>
                <ng-container *ngIf="!item.priceOverride && !!item.selectedPrice"
                              class="line-item-price"
                              [class.remove-padding]="removePadding"
                              [class.canceled-price]="orderStatus === orderStatuses.CANCELED"
                              (click)="useTokens($event)">
                    {{ adjustedPrice(item.selectedPrice.price) | currency }}
                </ng-container>
                <ng-container *ngIf="!item.menuItem && !item.priceOverride && !item.selectedPrice && !!item.total"
                              class="line-item-price"
                              [class.remove-padding]="removePadding"
                              [class.canceled-price]="orderStatus === orderStatuses.CANCELED"
                              (click)="useTokens($event)">
                    {{ adjustedPrice(item.total) | currency }}
                </ng-container>
                <ng-container *ngIf="additionalPrice"
                              class="line-item-price"
                              [class.remove-padding]="removePadding"
                              [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                    {{ adjustedPrice(additionalPrice) | currency }}
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!!item.tokenPayment"
                          class="line-item-price"
                          [class.remove-padding]="removePadding">
                <bb-tokens [count]="adjustedPrice(item.tokenPayment)"
                           [canceled]="orderStatus === orderStatuses.CANCELED"
                           (click)="$event.stopPropagation(); removeTokens.emit(item)"></bb-tokens>
            </ng-container>
        </ion-col>
    </ion-row>

    <bb-display-modifiers [groupedModifiers]="item.groupedModifiers"
                          [count]="count"
                          [hideTotal]="hideTotal"
                          [removePadding]="removePadding"
                          [orderStatus]="orderStatus"
                          [parentStyle]="parentRow()"
                          [childStyle]="childRow()"
    ></bb-display-modifiers>

    <ng-container *ngIf="item.removedToppingsFilter().length > 0">
        <ion-row>
            <ion-col [style]="parentRow()">
                <ion-text color="secondary">Removed Toppings</ion-text>
            </ion-col>
        </ion-row>
        <ion-row *ngFor="let topping of item.removedToppingsFilter()">
            <ion-col [style]="childRow()">
                {{ topping.menuItemTopping.topping.name }}
            </ion-col>
        </ion-row>
    </ng-container>

    <ng-container *ngIf="item.displayIncludedAndModifiedToppingsFilter().length > 0">
        <ng-container *ngFor="let topping of item.displayIncludedAndModifiedToppingsFilter()">
            <ion-row>
                <ion-col [style]="parentRow()">
                    <div class="line-item-container">
                        <div class="line-item-name">{{ topping.menuItemTopping.topping.name }}</div>
                        <div *ngIf="!hideTotal && topping.additionalPrice && topping.menuItemTopping.price != 0"
                             class="line-item-price"
                             [class.remove-padding]="removePadding"
                             [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                            {{ adjustedPrice(topping.additionalPrice) | currency }}
                        </div>
                    </div>
                </ion-col>
            </ion-row>

            <bb-display-modifiers [groupedModifiers]="topping.groupedModifiers"
                                  [count]="count"
                                  [hideTotal]="hideTotal"
                                  [removePadding]="removePadding"
                                  [orderStatus]="orderStatus"
                                  [parentStyle]="parentRow()"
                                  [childStyle]="childRow()"
            ></bb-display-modifiers>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="item.displayAddedToppingsFilter().length > 0">
        <ion-row>
            <ion-col [style]="parentRow()">
                <ion-text color="secondary">Added Toppings</ion-text>
            </ion-col>
        </ion-row>
        <ng-container *ngFor="let topping of item.displayAddedToppingsFilter()">
            <ion-row>
                <ion-col [style]="childRow()">
                    <div class="line-item-container">
                        <div class="line-item-name">{{ topping.menuItemTopping.topping.name }}</div>
                        <div *ngIf="!hideTotal && topping.additionalPrice && topping.menuItemTopping.price != 0"
                             class="line-item-price"
                             [class.remove-padding]="removePadding"
                             [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                            {{ adjustedPrice(topping.additionalPrice) | currency }}
                        </div>
                    </div>
                </ion-col>
            </ion-row>

            <bb-display-modifiers [groupedModifiers]="topping.groupedModifiers"
                                  [count]="count"
                                  [hideTotal]="hideTotal"
                                  [removePadding]="removePadding"
                                  [orderStatus]="orderStatus"
                                  [parentStyle]="parentRow()"
                                  [childStyle]="childRow()"
            ></bb-display-modifiers>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!!item.groupedToppings && item.groupedToppings.length > 0">
        <ng-container *ngFor="let toppingGroup of item.groupedToppings">
            <ion-row>
                <ion-col [style]="parentRow()">
                    <ion-text color="secondary">{{ toppingGroup.name }}</ion-text>
                </ion-col>
            </ion-row>
            <ng-container *ngFor="let topping of toppingGroup.toppings">
                <ion-row>
                    <ion-col [style]="childRow()">
                        <div class="line-item-container">
                            <div class="line-item-name">{{ topping.menuItemTopping.topping.name }}</div>
                            <div *ngIf="!hideTotal && topping.additionalPrice && topping.menuItemTopping.price != 0"
                                 class="line-item-price"
                                 [class.remove-padding]="removePadding"
                                 [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                                {{ adjustedPrice(topping.additionalPrice) | currency }}
                            </div>
                        </div>
                    </ion-col>
                </ion-row>

                <bb-display-modifiers [groupedModifiers]="topping.groupedModifiers"
                                      [toppingGroupName]="toppingGroup.name"
                                      [count]="count"
                                      [hideTotal]="hideTotal"
                                      [removePadding]="removePadding"
                                      [orderStatus]="orderStatus"
                                      [parentStyle]="childRow()"
                                      [childStyle]="childRow(1)"
                ></bb-display-modifiers>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-container *ngFor="let menuSelection of displaySelections">
        <ng-container
                *ngIf="(!!menuSelection.selectedItems && menuSelection.selectedItems.length > 0) || menuSelection.menuItemSelection.menuSelection.required">
            <ion-row *ngIf="!hideTotal && menuSelection.countTotal() != 0">
                <ion-col [style]="parentRow()">
                    <ion-text color="secondary">
                        <div class="line-item-container">
                            <div class="line-item-name">
                                {{
                                    menuSelection.menuItemSelection.menuSelection.name + (menuSelection.countTotal() != 0
                                        ? (' (x' + menuSelection.selectedItems.length + ')')
                                        : '')
                                }}
                            </div>
                            <div class="line-item-price"
                                 [class.remove-padding]="removePadding"
                                 [class.canceled-price]="orderStatus === orderStatuses.CANCELED">
                                {{ adjustedPrice(menuSelection.countTotal()) | currency }}
                            </div>
                        </div>
                    </ion-text>
                </ion-col>
            </ion-row>

            <ng-container *ngFor="let defaultItem of menuSelection.menuItemSelection.menuSelection.defaultOptions">
                <ion-row *ngIf="!defaultItem.printForDefault && defaultItem.removed">
                    <ion-col [style]="parentRow()">
                        <div class="line-item-container">
                            <div class="line-item-name">
                                Remove: {{ defaultItem.name }}
                            </div>
                        </div>
                    </ion-col>
                </ion-row>
            </ng-container>
            <ng-container *ngFor="let selection of menuSelection.selectedItems; trackBy: getId">
                <bb-display-order-item-selection-item
                        *ngIf="!selection.menuSelectionItem.defaultSelection || selection.menuSelectionItem.printForDefault || selection.orderItem.modifiers.length > 0"
                        [parent]="item"
                        [count]="count"
                        [selection]="selection"
                        [level]="level - 1"
                        [orderStatus]="orderStatus"
                        [hideTotal]="hideTotal">
                </bb-display-order-item-selection-item>
            </ng-container>
            <ion-row *ngIf="menuSelection.selectedItems.length === 0">
                <ion-col [style]="childRow()">
                    None
                </ion-col>
            </ion-row>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!!item.notes && !miscItem">
        <ion-row>
            <ion-col [style]="parentRow()">
                <ion-text color="tertiary">
                    Instructions:
                </ion-text>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col [style]="parentRow()">
                {{ item.notes }}
            </ion-col>
        </ion-row>
    </ng-container>

    <ng-container *ngIf="!hideTotal">
        <ion-row
                *ngIf="isTerminal && !!item.selectedPrice && orderStatus !== orderStatuses.CANCELED && editable && !!filteredComps && filteredComps.length > 0 && item.calcTotal() > item.calcCredits()">
            <ion-col size="12" class="ion-text-end">
                <a (click)="addCreditClicked($event)">Add Comp</a>
            </ion-col>
        </ion-row>
        <ion-row *ngFor="let credit of item.credits; trackBy: getId">
            <ion-col>
                <div class="comp-container">
                    <div class="comp-label ion-text-end">
                    <span *ngIf="!!credit.compDefinition">{{ credit.compDefinition.name }} <span
                            *ngIf="credit.compDefinition.type === compDefinitionTypes.PERCENT">({{ credit.compDefinition.amount }}%)</span></span>
                        <p>({{ adjustedPrice(credit.amount) | currency }})</p>
                    </div>
                    <div *ngIf="isTerminal && editable" class="comp-actions">
                        <ion-toolbar>
                            <ion-buttons>
                                <ion-button color="dark"
                                            [disabled]="!currentUser.authorizedTo(featureKeys.CREDIT_APPLY, organization.id) && (!credit.compDefinition || !currentUser.hasRole(credit.compDefinition.roles, organization.id))"
                                            (click)="removeCreditClicked($event, credit)">
                                    <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                                </ion-button>
                            </ion-buttons>
                        </ion-toolbar>
                    </div>
                </div>
            </ion-col>
        </ion-row>
    </ng-container>
</ion-grid>
